import React, { useState, Fragment, useEffect } from "react";
import "./table.css";
import datatable from "../../json/datatable.json";
import tableGroup from "../../json/tablegroup.json";
import { toBeDisabled } from "@testing-library/jest-dom/dist/matchers";
import { useParams, useHistory } from "react-router-dom";
import { getDetalleCanal } from "../../service/Service";

const DetalleInstitucion = () => {
  let history = useHistory();
  const [dataDetalle, setDataDetalle] = useState([]);
  const [dataDetalleCati, setDataDetalleCati] = useState([]);
  const [dataDetalleWeb, setDataDetalleWeb] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  // const randomDemo = (max, min) => Math.floor(Math.random() * (max - min)) + min;
  const { tableId, nomInstitucion } = useParams()
  const jsonDataMetodologia = datatable
  const jsonDataGrupo = tableGroup
  console.log(tableId);

  function TabPane({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && (
                <div>{children}</div>
            )}
        </div>
    );
  }

  function Tabs({ children }) {
    const [value, setValue] = useState(0);

    return (
        <div>
            <div>
                {React.Children.map(children, (child, index) => (
                    <button 
                        onClick={() => setValue(index)}
                        style={{
                            cursor: 'pointer',
                            padding: '10px 20px',
                            margin: '0 5px',
                            border: 'none',
                            borderRadius: '5px',
                            backgroundColor: value === index ? '#4CAF50' : '#E0E0E0',
                            color: value === index ? 'white' : 'black',
                            fontWeight: value === index ? 'bold' : 'normal'
                        }}
                    >
                        {child.props.label}
                    </button>
                ))}
            </div>
            <div>
                {React.Children.map(children, (child, index) => {
                    return React.cloneElement(child, { value, index });
                })}
            </div>
        </div>
    );
  }
  
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const {status, data} = await getDetalleCanal(tableId);
        // console.log(response);
        const {total, cati, limesurvey} = data.data;
        setDataDetalle(total);
        setDataDetalleCati(cati);
        setDataDetalleWeb(limesurvey);
      } catch (error) {
        // Manejo de errores
      }

      setIsLoading(false);
    };
    fetchData();
  }, [])
  return (
    <Fragment>
      <div style={{ width: "80%", margin: "30px auto" }}>
        <center><h3>{nomInstitucion}</h3></center>
        <button className="btn btn-sm btn-primary mb-4" onClick={() => history.push("/avance-instituciones")}>Volver</button>
        <Tabs>
          <TabPane label="TOTAL">
            <div style={{ margin: "40px auto" }}>
              <div id="table_1" className="table-responsive">
                <table className="table custom-table table-hover table-striped">
                  <thead className="titles">
                    <tr>
                      <th scope="col">Canales</th>
                      <th scope="col">Muestra Objetivo</th>
                      <th scope="col">Muestra lograda</th>
                      <th scope="col">% Realizado</th>
                      <th scope="col">Logrado<br/>último día</th>
                      <th scope="col">Logrado<br/>últimos 7 días</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    {isloading ? (
                    <tr>
                      <td className="text-center" colSpan="6">
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                      </td>
                    
                    </tr>
                  ) : dataDetalle.map((item, index) => {
                      return (
                        <tr key={`total_${index}`}>
                          <th className="text-center">
                            {item.nombre_canal}
                          </th>
                          <th className="text-center">{item.muestra_objetivo}</th>
                          <th className="text-center">{item.numero_respuestas}</th>
                          <th className="text-center">{item.porcentaje_respuestas}%</th>
                          <th className="text-center">{item.logrado_ultimos_dia}</th>
                          <th className="text-center">{item.logrado_ultimos_7_dias}</th></tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </TabPane>
          <TabPane label="CATI">
            <div style={{ margin: "40px auto" }}>
              <div id="table_1" className="table-responsive">
                <table className="table custom-table table-hover table-striped">
                  <thead className="titles">
                    <tr>
                      <th scope="col">Canales</th>
                      <th scope="col">Muestra Objetivo</th>
                      <th scope="col">Muestra lograda</th>
                      <th scope="col">% Realizado</th>
                      <th scope="col">Logrado<br/>último día</th>
                      <th scope="col">Logrado<br/>últimos 7 días</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    {isloading ? (
                    <tr>
                      <td className="text-center" colSpan="6">
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                      </td>
                    
                    </tr>
                  ): dataDetalleCati.map((item, index) => {
                      return (
                        <tr key={`cati_${index}`}>
                          <th className="text-center">
                            {item.nombre_canal}
                          </th>
                          <th className="text-center">{item.muestra_objetivo}</th>
                          <th className="text-center">{item.numero_respuestas}</th>
                          <th className="text-center">{item.porcentaje_respuestas}%</th>
                          <th className="text-center">{item.logrado_ultimos_dia}</th>
                          <th className="text-center">{item.logrado_ultimos_7_dias}</th>
                        </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </TabPane>
          <TabPane label="WEB">
            <div style={{ margin: "40px auto" }}>
              <div id="table_1" className="table-responsive">
                <table className="table custom-table table-hover table-striped">
                  <thead className="titles">
                    <tr>
                      <th scope="col">Canales</th>
                      <th scope="col">Muestra Objetivo</th>
                      <th scope="col">Muestra lograda</th>
                      <th scope="col">% Realizado</th>
                      <th scope="col">Logrado<br/>último día</th>
                      <th scope="col">Logrado<br/>últimos 7 días</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    {isloading ? (
                    <tr>
                      <td className="text-center" colSpan="6">
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                      </td>
                    
                    </tr>
                  ):dataDetalleWeb.map((item, index) => {
                      return (
                        <tr key={`web_${index}`}>
                          <th className="text-center">{item.nombre_canal}</th>
                          <th className="text-center">{item.muestra_objetivo}</th>
                          <th className="text-center">{item.numero_respuestas}</th>
                          <th className="text-center">{item.porcentaje_respuestas}%</th>
                          <th className="text-center">{item.logrado_ultimos_dia}</th>
                          <th className="text-center">{item.logrado_ultimos_7_dias}</th>
                        </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </TabPane>
        </Tabs>

        {/* Botón de descarga */}
        <div style={{ textAlign: "right" }}>
          <button className="btn btn-primary">
            Descargar Excel
          </button>
        </div>
      </div>
    </Fragment>
  );
};
export default DetalleInstitucion;
